export default "__VITE_ASSET__0b3aa389__"